// extracted by mini-css-extract-plugin
export default {"input":"ijcx1","inputInvalid":"_4vGtX","link":"aLfcw"};